import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(value: any[], property?: string): any[] {
    if (!value) {
      return value;
    }
    return value.sort((a, b) => {
      if (property) {
        a = a[property];
        b = b[property];
      }
      return a.localeCompare(b, 'en', { ignorePunctuation: true });
    });
  }
}
